import { ipc_invoke } from '@/tauri/ipc';

type CpuArchResponse = { arch: string };
type DesktopOsVersionResponse = { desktopOsVersion: string };
type KeyboardLayoutResponse = { layoutId: string };

/**
 * Host machine capability facts. An absent property means "unknown", never
 * "zero" — Rust omits what the machine did not answer.
 *
 * Typed loosely on purpose: the authoritative allowlist for what reaches
 * Datadog is the const field list in `setDatadogHostSpecs`, not this type.
 */
export type HostSpecsResponse = {
  hwCpuModel?: string;
  hwCpuPhysicalCores?: number;
  hwCpuLogicalCores?: number;
  hwMemTotalBytes?: number;
  hwDiskTotalBytes?: number;
  hwDiskAvailableBytes?: number;
};

class SystemController {
  async get_cpu_architecture(): Promise<string> {
    return ipc_invoke('get_cpu_architecture', {}).then(
      (res: { data: CpuArchResponse }) => res.data.arch
    );
  }

  async get_desktop_os_version(): Promise<string> {
    return ipc_invoke('get_desktop_os_version', {}).then(
      (res: { data: DesktopOsVersionResponse }) => res.data.desktopOsVersion
    );
  }

  async get_host_specs(): Promise<HostSpecsResponse> {
    return ipc_invoke('get_host_specs', {}).then(
      (res: { data: HostSpecsResponse }) => res.data
    );
  }

  async get_keyboard_layout(): Promise<string> {
    return ipc_invoke('get_keyboard_layout', {}).then(
      (res: { data: KeyboardLayoutResponse }) => res.data.layoutId
    );
  }
}

export const systemController = new SystemController();
